import PropTypes from 'prop-types';

import { ListingCostsShape } from '../../constants/shapes';

import OnBookingClosed from './OnBookingClosed';
import BeforeMoveIn from './BeforeMoveIn';
import BeforeMoveOut from './BeforeMoveOut';
import DuringStay from './DuringStay';
import ExtraServices from './ExtraServices';

import styles from './PaymentDetails.module.scss';

const PaymentDetails = ({
  listingCosts = {},
  pricing = {},
  downPaymentTimeInterval = undefined,
  isInstantBooking = false,
  hasNoDeposit = false,
  hasDepositProtection = false,
  currencyIsoCode,
  contractDurationType = 'temporal',
  hideDepositElanLaw = false,
  unCollapseAll = false,
  onAddDatesClick = null,
  isSeasonalPricing = false
}) => {
  const onCheckOutCosts = listingCosts?.onCheckOut;
  const onCheckOutCostList = onCheckOutCosts?.costs ?? [];
  const showBeforeMoveOut = onCheckOutCostList.length > 0;
  const extraCostList = listingCosts?.extra?.costs ?? [];
  const showExtraServices = extraCostList.length > 0;
  const isCollapsed = !unCollapseAll;

  return (
    <div className={styles['payment-details']}>
      <OnBookingClosed
        currencyCode={currencyIsoCode}
        pricing={pricing}
        costs={listingCosts?.onBookingClosed}
        downPaymentTimeInterval={downPaymentTimeInterval}
        isInstantBooking={isInstantBooking}
        onAddDatesClick={onAddDatesClick}
      />
      <BeforeMoveIn
        currencyCode={currencyIsoCode}
        costs={listingCosts?.onCheckIn}
        hasNoDeposit={hasNoDeposit}
        hasDepositProtection={hasDepositProtection}
        hideDepositElanLaw={hideDepositElanLaw}
        isCollapsed={isCollapsed}
      />
      <hr className={styles['payment-details__divider']} />
      <DuringStay
        costs={listingCosts?.duringStay}
        currencyCode={currencyIsoCode}
        contractDurationType={contractDurationType}
        isCollapsed={isCollapsed}
        isSeasonalPricing={isSeasonalPricing}
      />
      {showBeforeMoveOut ? (
        <>
          <hr className={styles['payment-details__divider']} />
          <BeforeMoveOut
            costs={onCheckOutCosts}
            currencyCode={currencyIsoCode}
            isCollapsed={isCollapsed}
          />
        </>
      ) : null}
      {showExtraServices ? (
        <>
          <hr className={styles['payment-details__divider']} />
          <ExtraServices
            costs={listingCosts.extra}
            currencyCode={currencyIsoCode}
            isCollapsed={isCollapsed}
          />
        </>
      ) : null}
    </div>
  );
};

PaymentDetails.propTypes = {
  pricing: PropTypes.shape({
    currencyCode: PropTypes.string,
    currencyIsoCode: PropTypes.string,
    totalContractValue: PropTypes.number
  }),
  listingCosts: PropTypes.shape({
    onBookingClosed: ListingCostsShape,
    onCheckIn: ListingCostsShape,
    duringStay: ListingCostsShape,
    onCheckOut: ListingCostsShape,
    extra: ListingCostsShape
  }),
  downPaymentTimeInterval: PropTypes.shape({
    type: PropTypes.oneOf(['months', 'weeks']),
    value: PropTypes.number
  }),
  isInstantBooking: PropTypes.bool,
  hasNoDeposit: PropTypes.bool,
  hasDepositProtection: PropTypes.bool,
  currencyIsoCode: PropTypes.string.isRequired,
  contractDurationType: PropTypes.string,
  hideDepositElanLaw: PropTypes.bool,
  unCollapseAll: PropTypes.bool,
  onAddDatesClick: PropTypes.func,
  isSeasonalPricing: PropTypes.bool
};

export default PaymentDetails;
